import { createApp } from 'vue'
import ArcoVue from '@arco-design/web-vue';
import App from './App.vue'
import router from './router';
import ElementPlus from 'element-plus'
import { createPinia } from 'pinia';
import 'element-plus/dist/index.css'
import '@arco-design/web-vue/dist/arco.css';
import ArcoVueIcon from '@arco-design/web-vue/es/icon';
import './permission';
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import { useUserStore } from "@/store/modules/user"
import * as MyIcons from './icon'; // 导入所有图标
import EditButton from './components/EditButton.vue';
import VxeUIAll from 'vxe-pc-ui'
import 'vxe-pc-ui/es/style.css'
import VxeUITable from 'vxe-table'
import 'vxe-table/es/style.css'
import VxeUIDesign from 'vxe-design'
import 'vxe-design/lib/style.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'


import exportXlsx from 'vxe-table-plugin-export-xlsx'
import * as XLSX from 'xlsx'


// import VxeTablePluginPrint from 'vxe-table-plugin-print'
// import 'vxe-table-plugin-print/lib/style.css'


const app = createApp(App);

// app.use(VxeTable)



// VxeTable.use(VxeTablePluginPrint)

// 批量注册自定义图标
for (const [key, component] of Object.entries(MyIcons)) {
    app.component(key, component);
}

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

// 初始化 Pinia
const pinia = createPinia();
app.use(pinia);
app.use(ArcoVueIcon);
app.use(router);
app.use(ArcoVue);
app.use(ElementPlus, {
    locale: zhCn,
});
app.use(VxeUIAll);
app.use(VxeUITable);
app.use(VxeUIDesign);

VxeUITable.use(exportXlsx, { xlsx: XLSX })

// 全局屏蔽所有 Vue 警告
app.config.warnHandler = () => {}
const userStore = useUserStore()
const permission = {
    mounted(el, binding) {
        const { value } = binding;
        // 权限列表（实际应从store获取）
        const userPermissions = userStore.user.permission;

        // 处理数组形式的权限
        if (Array.isArray(value)) {
            // 检查用户是否有任一要求的权限
            const hasPermission = value.some(perm => userPermissions.includes(perm));
            if (!hasPermission) {
                el.parentNode?.removeChild(el);
            }
        }
        // 处理字符串形式的权限
        else if (typeof value === 'string') {
            if (!userPermissions.includes(value)) {
                el.parentNode?.removeChild(el);
            }
        }
        // 无效的权限值
        else {
            console.error('v-permission 需要传入字符串或数组');
            el.parentNode?.removeChild(el);
        }
    }
};

app.component('EditButton', EditButton)
// 全局注册指令
app.directive('permission', permission)

app.mount('#app');
